import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import Root from "./app/Root";
import {
  configureReporting,
  configureStore,
  configureAxios,
  config
} from "./config";

import registerServiceWorker from "./registerServiceWorker";

configureAxios();

const initialState = {};

const reportingMiddleware = configureReporting({
  appVersion: config.appVersion,
  sentryUrl: config.sentryUrl,
  unhandledRejection: fn => window.addEventListener("unhandledrejection", fn)
});

const store = configureStore({
  initialState,
  platformDeps: {},
  platformMiddleware: [reportingMiddleware]
});

ReactDOM.render(<Root store={store} />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js